module.exports = __webpack_public_path__ + "Gotham_Book_Regular.a563635d2c187f9399dc.otf";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/fonts/Gotham_Book_Regular.otf
// module id = ../../../../../src/assets/fonts/Gotham_Book_Regular.otf
// module chunks = styles